import { Emitter } from "./widget"

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || ""
}

export class JsonResource extends Emitter {
  constructor(attributes = {}) {
    super()
    this.attributes = { ...attributes }
    this.id = attributes.id
  }

  get(name) {
    return this.attributes[name]
  }

  urlRoot() {
    throw new Error("urlRoot() must be implemented")
  }

  url() {
    return this.id ? `${this.urlRoot()}/${this.id}` : this.urlRoot()
  }

  async save(attributes = {}, options = {}) {
    const previous = { ...this.attributes }
    Object.assign(this.attributes, attributes)
    const method = this.id ? "PATCH" : "POST"

    try {
      const response = await fetch(this.url(), {
        method,
        credentials: "same-origin",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken()
        },
        body: JSON.stringify(this.attributes)
      })
      if (!response.ok) throw new Error(`Request failed (${response.status})`)
      const payload = response.status === 204 ? {} : await response.json()
      const normalized = payload && typeof payload === "object" ? payload : {}
      Object.assign(this.attributes, normalized)
      this.id = this.attributes.id || this.id

      Object.keys(this.attributes).forEach((key) => {
        if (previous[key] !== this.attributes[key]) this.emit(`change:${key}`, this)
      })
      this.emit("sync", this)
      options.success?.call(options.context || this, this, normalized)
      return this
    } catch (error) {
      options.error?.call(options.context || this, this, error)
      throw error
    }
  }
}

export class Submission extends JsonResource {
  urlRoot() {
    return `/assignments/${this.get("assignment_id")}/submissions`
  }
}

export class DocumentResource extends JsonResource {
  urlRoot() {
    return "/documents"
  }
}

export class CompletedVideoLesson extends JsonResource {
  urlRoot() {
    return `/assignments/${this.get("assignment_id")}/complete_video_lesson`
  }
}

window.Submission = Submission
window.WbdDocument = DocumentResource
